import PubSub from 'pubsub-js';

PubSub.subscribe('init', () => {
  const siteUrl = $('.header').data('site-url');
  $('.header__logo').on('click', () => {
    sessionStorage.clear();
    location.href = siteUrl;
  });
});